import { MenuItem } from '@intigral/shared/components/MenuList';
import { Link } from 'react-router-dom';
import { useContext } from 'react';
import { MixpanelContext } from '../../../../contexts/MixpanelContext';
import { EVENT } from '../../../../contexts/MixpanelConstants';
import { FlexWrapper, FontIcon, Text } from '@intigral/shared';
import { FlexChild } from '@intigral/shared/components/FlexWrapper';
import { __ } from '../../../../translations';
import useLanguage from '../../../../hooks/useLanguage';
import { isGamificationEnabled } from '../../../gamification/utils/GamificationUtils';

export const RewardMenu = () => {
    const { track }: any = useContext(MixpanelContext);
    const language = useLanguage();
    const gamificationConfig = isGamificationEnabled();

    if (gamificationConfig?.enable) {
        return (
            <MenuItem
                variant="link"
                href={language === 'en' ? '/en/rewards' : '/rewards'}
                linkAs={Link}
                linkProps={{
                    to: language === 'en' ? '/en/rewards' : '/rewards',
                }}
                onClick={() => {
                    track(EVENT.GAMIFICATION.REWARDS_DASHBORAD_VIEWED, {
                        'Screen Name': 'More Screen',
                    });
                }}
                data-test-id="profile-menu-rewards"
            >
                <FlexWrapper justifyContent="between" flexGrow gap="2x">
                    <FlexChild>
                        <FlexWrapper gap="2x">
                            <FontIcon md="smaller" name="reward" size="smaller" />
                            {__('rewards_menu_link')}
                        </FlexWrapper>
                    </FlexChild>
                    <FlexChild>
                        <Text as="span" variant="text4" color="orange">
                            {__('rewards_menu_new_tag')}
                        </Text>
                    </FlexChild>
                </FlexWrapper>
            </MenuItem>
        );
    }
};
